module.exports = __webpack_public_path__ + "img/FAVORITOS.72a7cba0.png";